import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Select, Form, Button, Input, Upload, message, Typography, Icon, Card, Breadcrumb, Radio, Divider, Tabs, DatePicker, Modal } from 'antd';
import { getStaticProTime, getStaticProList, getStaticFinishPer, getStaticProTaskOrMember, getStaticProRealInfo, getStaticProFinishPro, getStaticProExpiryRate, getStaticProOrTaskInfo } from '@/api/api';
import moment from 'moment';
import echarts from 'echarts';
import utils from '@/api/util';
import './statistical.css';
import servers from '@/api/server';

const FormItem = Form.Item;
const Option = Select.Option;
const { TabPane } = Tabs;
const { Text, Title } = Typography;
const RangePicker = DatePicker.RangePicker;

let mutiPro_cavans, singlePro_cavans, expiry_cavans, proOrTask_cavans;

class Statistic_project extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            pro_tab: 1,
            dueStat_tab: 1,
            proList: [],
            proIds: [],
            proIds_2: [],
            proNum: 0,
            jobNum: 0,
            userNum: 0,
            ch_Width: '',
            expiryJobPer: 0,
            expiryProPer: 0,
            compEcharts_flag: true,
            prosEcharts_flag: true,
            noFinishTaskArr: []
        }
        this.getProList = this.getProList.bind(this);
        this.statistic_proChange = this.statistic_proChange.bind(this);
        this.finishPerHandle = this.finishPerHandle.bind(this);
        this.comprehensiveSwitch = this.comprehensiveSwitch.bind(this);
        // this.getProUpdate=this.getProUpdate.bind(this);
        this.taskOrMemberHandle = this.taskOrMemberHandle.bind(this)
        this.taskOrMember = this.taskOrMember.bind(this);
        this.materialCostHandle = this.materialCostHandle.bind(this);
        this.finishProgressHandle = this.finishProgressHandle.bind(this);
        this.proIdsChange = this.proIdsChange.bind(this);
        // this.getProOrTaskInfoData=this.getProOrTaskInfoData.bind(this);
        // this.getExpiryRate = this.getExpiryRate.bind(this);//2
        // this.expiryMenuSwitch = this.expiryMenuSwitch.bind(this);//2
        this.expiryRangeChange = this.expiryRangeChange.bind(this)
    }

    componentDidMount() {
        mutiPro_cavans = echarts.init(document.getElementById('pro_progress_echarts'));
        singlePro_cavans = echarts.init(document.getElementById('comprehensiveStat'));
        mutiPro_cavans.showLoading();
        // expiry_cavans.showLoading();//2
        singlePro_cavans.showLoading()
        let nowTime = (new Date()).getTime();
        let nowDate = utils.formatTimestamp(nowTime, 'date');
        let nowMonth = utils.formatTimestamp(nowTime, 'yearMonth');
        this.getProList()
        this.finishPerHandle({})
    }

    // 获取项目列表
    getProList() {
        let that = this;
        getStaticProList({}, res => {
            console.log(res)
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                proList: res.proList
            });
        }, err => {
            console.log(err)
        })
    }

    // 选择项目，最多5项
    proIdsChange(value, option, flag) {
        const that = this;
        if (value.length > 5) {
            // message.error('最多只能选择5项', 2)
            Modal.error({
                content: '最多只能选择5项',
            });
            return
        }
        console.log(value)
        if (flag === 1) {
            that.setState({
                proIds: value,
                proId: parseInt(value[0]),
                pro_tab: 1
            });
            that.finishPerHandle({ ids: value.toString() });
        }
        if (flag === 2) {
            that.setState({
                proIds_2: value,
            });
            that.getProOrTaskInfoData({ ids: value.toString() })
        }
    }

    // 多个项目进度情况
    finishPerHandle(params) {
        const that = this;
        console.log(params);
        mutiPro_cavans.showLoading()
        getStaticFinishPer(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                proIds_num: res.ids,
                proId: res.ids[0],
                prosEcharts_flag: res.finishPer && res.finishPer.length > 0
            });
            that.taskOrMemberHandle(res.ids[0]);
            that.statistic_proChange(res);
        }, err => {
            console.log(err)
        })
    }

    // 多个项目进度图表绘制
    statistic_proChange(values) {
        const that = this;
        mutiPro_cavans.clear();
        let seriesData = [];
        values.finishPer.map((x, index) => {
            let data = {};
            data.value = x.toFixed(2);
            if (index === 0) {
                data.itemStyle = {
                    normal: {
                        color: '#62a0a8',
                        borderWidth: 0,
                        borderColor: '#62a0a8'
                    }
                }
            } else {
                let r = Math.floor(Math.random() * 256);
                let g = Math.floor(Math.random() * 256);
                let b = Math.floor(Math.random() * 256);
                data.itemStyle = {
                    normal: {
                        color: "rgb(" + r + ',' + g + ',' + b + ")",
                    }
                }
            };
            seriesData.push(data)
        })
        mutiPro_cavans.setOption({
            title: {
                text: '项目进度情况',
                subtext: '（默认选取即将截止的TOP5项目）',
                left: 'center'
            },
            grid: {
                left: '3%',
                right: '15%',
                // top: 80,
                // bottom:0,
                containLabel: true
            },
            xAxis: [
                {

                    max: 1,
                    type: 'value',
                    axisLabel: {
                        formatter: (value, index) => {
                            return (value * 100) + '%'
                        }
                    }
                }
            ],
            yAxis: [
                {
                    type: 'category',
                    data: values.proName,
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        rotate: 40,
                        formatter: (value, index) => {
                            let txt = '';
                            let val = value;
                            if (val.length > 6) {
                                val = value.substr(0, 5) + '..'
                            }
                            if (values.ifChild[index] === 1) {
                                // txt += '<span style="color:#f2f5f7;padding:2px 5px;font-size:12px;border-radius:2px">子</span>';
                                return ['{a|子}', val].join(' ');
                            } else {
                                return val
                            }
                        },
                        padding: [0, 0, 0, 24],
                        rich: {
                            a: {
                                // color: 'red',
                                backgroundColor: '#f2f5f7',
                                padding: [2, 4, 2, 4],
                                borderRadius: 2,
                                fontSize: 9
                            }
                        }
                    }
                }
            ],
            series: [
                {
                    type: 'bar',
                    stack: '总量',
                    data: seriesData,
                    z: 3,
                    label: {
                        normal: {
                            formatter: function (params) {
                                console.log(params)
                                return (parseFloat(params.value) * 100).toFixed(1) + '%(' + values.lostTime[params.dataIndex] + ')'
                            },
                            show: true,
                            position: 'right',
                            color: '#333333'
                        }
                    },
                    barMinHeight: 5,
                    barWidth: 40
                }
            ]
        });
        mutiPro_cavans.on('click', params => {
            if (that.proIdFlag) {
                return
            };
            that.proIdFlag = true;
            that.setState({
                proId: parseInt(that.state.proIds_num[params.dataIndex]),
                pro_tab: 1,
                ch_Width: '',
                compEcharts_flag: true
            });
            that.taskOrMemberHandle(that.state.proIds_num[params.dataIndex])
        });
        mutiPro_cavans.hideLoading()
    }

    //单个项目任务/人员图表数据获取
    taskOrMemberHandle(id) {
        const that = this;
        singlePro_cavans.showLoading()
        getStaticProTaskOrMember({ proId: id ? parseInt(id) : that.state.proId }, res => {
            console.log(res);
            that.proIdFlag = false;
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                compEcharts_flag: (res.per && res.per.length > 0) || (res.jobPer && res.jobPer.length > 0)
            });
            that.taskOrMember(res)
        }, err => {
            console.log(err)
        })
    }

    //单个项目任务/人员图表绘制
    taskOrMember(values) {
        const that = this;
        singlePro_cavans.clear();
        let datas = [];
        values.userName.map((x, index) => {
            let ret = {};
            ret.name = x;
            ret.value = (values.per[index].toFixed(2)) * 100;
            datas.push(ret)
        });
        singlePro_cavans.setOption({
            title: {
                text: values.proName,
                left: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b}:{d}%",
                textStyle: {
                    align: 'left'
                }
            },
            series: [
                {
                    name: '任务占比',
                    type: 'pie',
                    selectedMode: 'single',
                    radius: [0, '30%'],
                    label: {
                        normal: {
                            position: 'inner',
                            formatter: params => {
                                return params.name.length > 5 ? params.name.substr(0, 5) + '..' : params.name
                            }
                        }
                    },
                    tooltip: {
                        formatter: params => {
                            let str = '<h3 style="color:#fff;font-size:14px">' + params.seriesName + '</h3>';
                            str += '<p style="max-width:400px;font-size:12px;oversflow:hidden;word-break: break-all;white-space: pre-wrap;">' + params.data.name + ':' + (parseFloat(params.data.value) * 100).toFixed(1) + '%</p>'
                            return str;
                        }
                    },
                    labelLine: {
                        normal: {
                            show: false
                        }
                    },
                    data: [
                        { value: values.jobPer[0], name: values.jobName[0], selected: true },
                        { value: values.jobPer[1], name: values.jobName[1] },
                        { value: values.jobPer[2], name: values.jobName[2] }
                    ]
                },
                {
                    name: '成员任务占比',
                    type: 'pie',
                    radius: ['40%', '55%'],
                    label: {
                        normal: {
                            formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{per|{d}%} ',
                            backgroundColor: '#eee',
                            borderColor: '#aaa',
                            borderWidth: 1,
                            borderRadius: 4,
                            rich: {
                                a: {
                                    color: '#999',
                                    lineHeight: 22,
                                    align: 'center'
                                },
                                hr: {
                                    borderColor: '#aaa',
                                    width: '100%',
                                    borderWidth: 0.5,
                                    height: 0
                                },
                                b: {
                                    fontSize: 16,
                                    lineHeight: 33
                                },
                                per: {
                                    color: '#eee',
                                    backgroundColor: '#334455',
                                    padding: [2, 4],
                                    borderRadius: 2
                                }
                            }
                        }
                    },
                    data: datas
                }
            ]
        });
        singlePro_cavans.hideLoading()

    }

    //单个项目耗材成本图表数据获取
    materialCostHandle(id) {
        const that = this;
        let params = {
            proId: id ? id : that.state.proId,
            type: 1
        };
        singlePro_cavans.showLoading()
        getStaticProRealInfo(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                compEcharts_flag: res.per && res.per.length > 0
            });
            that.materialCost(res)
        }, err => {
            console.log(err)
        })
    }

    //单个项目耗材成本图表绘制
    materialCost(values) {
        const that = this;
        singlePro_cavans.clear();
        let datas = [];
        values.reaName.map((x, index) => {
            let ret = {};
            ret.value = (values.per[index] * 100).toFixed(1);
            ret.name = x;
            datas.push(ret)
        })
        singlePro_cavans.setOption({
            title: {
                text: values.proName + '耗材成本占比',
                x: 'center'
            },
            tooltip: {
                trigger: 'item',
                formatter: (params) => {
                    return params.seriesName + '<br/>' + params.name + ':' + params.value + '%(￥' + values.money[params.dataIndex] + ')'
                },
                textStyle: {
                    align: 'left'
                }
            },
            legend: {
                orient: 'vertical',
                right: 10,
                bottom: 20,
                data: values.reaName,
                formatter: function (name) {
                    if (name.length > 16) {
                        return name.substr(0, 15) + '..'
                    }
                    return name;
                }
            },
            series: [
                {
                    name: '耗材成本占比',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '50%'],
                    data: datas,
                    label: {
                        formatter: (params) => {
                            if (params.name.length > 16) {
                                return params.name.substr(0, 15) + '..'
                            };
                            return params.name;
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        });
        singlePro_cavans.hideLoading()
    }

    // 单个项目进度情况图表数据获取
    finishProgressHandle(id) {
        const that = this;
        let params = {
            proId: id ? id : that.state.proId,
        };
        getStaticProFinishPro(params, res => {
            console.log(res);
            if (res.statusCode !== 1000) {
                return
            };
            that.setState({
                compEcharts_flag: res.time && res.time.length > 1,
                noFinishTaskArr: res.job
            });
            that.finishProgress(res)
        }, err => {
            console.log(err)
        })
    }

    // 单个项目进度情况图表绘制
    finishProgress(values) {
        const that = this;
        singlePro_cavans.clear();
        let proArr = [];  //完成进度
        if (values.finishPer.length < 1) {
            return
        };
        let allArr = new Array(values.finishPer.length - 1).fill(null); //全部进度
        values.finishPer.map((x, index) => {
            proArr.push({
                value: x,
                label: { show: false }
            });
        });
        if (!(values.finishPer.length === values.time.length)) {
            allArr[values.finishPer.length - 1] = {};
            allArr[values.finishPer.length - 1].label = { show: false }
            allArr[values.finishPer.length - 1].value = values.finishPer[values.finishPer.length - 1]
            allArr[values.time.length - 1] = 100
        };
        singlePro_cavans.setOption({
            title: {
                text: values.proName + '完成进度情况',
                x: 'center'
            },
            grid: {
                left: '10%',
                right: '20%'
            },

            xAxis: {
                interval: (index, value) => {
                    return index === 0 || index === values.time.length - 1 || (!(values.finishPer.length === values.time.length) && index === values.time.length - 2)
                },
                type: 'category',
                boundaryGap: false,
                data: values.time,
                axisLabel: {
                    interval: 0,
                    formatter: (value, index) => {
                        if (index === 0) {
                            return '项目开始时间' + value.split(' ')[0]
                        };
                        if (index === values.time.length - 1) {
                            return value.split(' ')[0]
                        };
                        if ((!(values.finishPer.length === values.time.length) && index === values.time.length - 2)) {
                            console.log('当前进度' + value.split(' ')[0])
                            return '当前进度' + value.split(' ')[0]
                        };
                        return ''
                    }
                }
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}%'
                }
            },
            tooltip: {
                trigger: 'axis',
                formatter: '进度: {c0}%<br />{b0}',
                axisPointer: {
                    type: 'cross',
                    label: {
                        backgroundColor: '#6a7985'
                    }
                }
            },
            series: [{
                name: '进度',
                data: proArr,
                type: 'line',
                areaStyle: {},
                label: {
                    normal: {
                        show: true,
                        position: 'top'
                    }
                },
            }, {
                name: '未完成任务',
                data: allArr,
                type: 'line',
                areaStyle: {
                    normal: {

                    }
                },
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        formatter: '{c}%'
                    },
                },

            }]
        });
        singlePro_cavans.hideLoading()
    }

    // 项目过期率/任务过期率时间段更改
    expiryRangeChange(value, mode) {
        const that = this;

        that.setState({
            expiryRange: value
        });
        this.getExpiryRate({
            type: that.state.dueStat_tab,
            beginTime: value[0].format('YYYYMM'),
            endTime: value[1].format('YYYYMM')
        })
    }


    // 项目综合统计中，切换选项
    comprehensiveSwitch(e) {
        const that = this;
        this.setState({
            pro_tab: e.target.value,
            compEcharts_flag: true,
            ch_Width: ''
        });
        if (e.target.value === 1) {
            this.taskOrMemberHandle()
        } else if (e.target.value === 2) {
            this.materialCostHandle()
        } else if (e.target.value === 3) {
            this.finishProgressHandle();
            that.setState({
                ch_Width: '74%'
            })
        }
    }


    render() {
        const that = this;
        const { userNum, ch_Width, noFinishTaskArr, jobNum, proNum, proList, proIds, expiryJobPer, expiryProPer, proIds_2, compEcharts_flag, prosEcharts_flag } = this.state;
        return (
            <div className="statistic">
                <Card
                    style={{ height: '495px', overflow: 'hidden' }}
                    title={
                        <div className="pr">
                            <Text strong className="mr5" style={{fontSize:'15px'}}><i className="iconfont icon-shuju1 c_8bff mr5 vm"></i>课题综合统计</Text>
                            <Select
                                mode="multiple"
                                value={proIds}
                                onChange={(value, option) => this.proIdsChange(value, option, 1)}
                                placeholder="选择课题"
                                maxTagCount={5}
                                className="pa_rm"
                                style={{ minWidth: '140px' }}
                            >
                                {proList.map(x => {
                                    return (
                                        <Option value={x.id.toString()} key={x.id} title={x.projectName}>
                                            {x.projectName.length > 9 ? x.projectName.substr(0, 8) + '..' : x.projectName}
                                        </Option>
                                    )
                                })}
                            </Select>
                        </div>
                    }
                    className="statistic_panel"
                >
                    <div className="statistic_pro_progress pr">
                        {!prosEcharts_flag &&
                            <img src={servers.defaultNoContentPath} alt="暂无内容" className="noContent" />
                        }
                        <div id="pro_progress_echarts" className="statistic_pro_tabPane"></div>
                    </div>
                    <div className="statistic_pro_tabPane" id="comprehensiveStat"></div>

                </Card>

            </div>
        )
    }
}


export default Statistic_project;

